export default class MyAccount {
    constructor() {
        this.navGlobal = document.querySelector('.nav__global');
        this.myAccount = this.navGlobal?.querySelector('.my-account');
        this.navLogin = this.myAccount?.querySelector('.nav__login');
        this.navLoginText = this.myAccount?.querySelector('.nav__login__text');
        this.navDropdown = this.myAccount?.querySelector('.dropdown');
        this.expandedNavFlyout = null;

        if (this.myAccount) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.navLogin?.addEventListener('click', (e) => {
            const isExpanded = this.navLoginText.classList.contains('active');
            this.toggle(!isExpanded);
        });

        this.navDropdown?.addEventListener('focusout', (e) => {
            if (!this.navDropdown.contains(e.relatedTarget)) {
                this.toggle(false);
            }
        });

        this.navDropdown?.addEventListener('keydown', (e) => {
            e.stopPropagation();
            if (e.key === 'Escape') {
                this.toggle(false);
            }
        });

        document.addEventListener('click', (e) => {
            if (!this.myAccount.contains(e.target)) {
                this.toggle(false);
            }
        });
    }

    toggle(isActive) {
        this.navGlobal.classList.toggle('dropdown-overlay', isActive);
        this.navLogin?.setAttribute('aria-expanded', isActive);
        this.navLoginText?.classList.toggle('active', isActive);
        this.navDropdown?.classList.toggle('show', isActive);
        this.navDropdown?.setAttribute('aria-expanded', isActive);
        this.expandedNavFlyout = document.querySelector('.nav__flyout.items--expanded');

        if (isActive) {
            this.navDropdown?.querySelector('a, button, [tabindex]')?.focus();

            if (this.expandedNavFlyout) {
                this.expandedNavFlyout.style.zIndex = '-3';
            }
        } else {
            if (this.expandedNavFlyout) {
                this.expandedNavFlyout.style.zIndex = '';
            }
        }
    }
}
